import React from 'react'
import PropTypes from 'prop-types'

function FlexGrid ({ children, className, cols, grow, spacing, responsive, wrap }) {
  const classNames = [
    'flex-grid',
    'flex',
    'flex-grid--' + cols,
    'flex-grid--spacing-' + spacing,
    wrap ? 'flex-wrap' : 'flex-no-wrap',
    grow ? 'flex-grid--grow' : '',
    responsive.xl ? 'xl:flex-grid--' + responsive.xl : '',
    responsive.lg ? 'lg:flex-grid--' + responsive.lg : '',
    responsive.md ? 'md:flex-grid--' + responsive.md : '',
    responsive.sm ? 'sm:flex-grid--' + responsive.sm : ''
  ]

  return (
    <div className={className}>
      <div className={classNames.join(' ')}>
        {children}
      </div>
    </div>
  )
}

FlexGrid.defaultProps = {
  className: 'my-4',
  cols: 1,
  grow: false,
  wrap: true,
  spacing: 'normal',
  responsive: {
    xl: null,
    lg: null,
    md: null,
    sm: null
  }
}

FlexGrid.propTypes = {
  /**
     * Add a custom className to the grid's wrapper
     */
  className: PropTypes.string,
  /**
     * Number of columns in the grid.
     * Default: 1
     */
  cols: PropTypes.number,
  /**
     * Controls if the grid elements should grow to fill the grid
     * Default: false
     */
  grow: PropTypes.bool,
  /**
     * Controls if the grid elements should wrap
     * (can be used to create a scrollable container instead)
     * Default: true
     */
  wrap: PropTypes.bool,
  /**
     * Spacing size for the grid elements
     * Default: 'normal'
     * Options: 'normal, 'large'
     */
  spacing: PropTypes.string,
  /**
     * Control the different breakpoints.
     * Example: { xl: 5, lg:4, md:3, sm:2 }
     * The example will create 5 columns on xl screens, 4 on lg etc.
     * It will use default cols, when screen is smaller than the smallest used breakpoint
     */
  responsive: PropTypes.object
}

export default FlexGrid
